import { render, staticRenderFns } from "./VideoConferenceSettings.vue?vue&type=template&id=3aa56776&"
import script from "./VideoConferenceSettings.vue?vue&type=script&lang=js&"
export * from "./VideoConferenceSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports